import { InputLabel, TextField, Typography } from '@mui/material';
import { useMask } from '@react-input/mask';

import { cssprefix, flattenIntoKey } from '@/components/DynamicForm/utils/utils';
import { DateTextInputElement } from '@/components/DynamicForm/types/DynamicFormTypes';
import { publish } from '@/components/DynamicForm/events';

const maskStr = 'MM/DD/YYYY';

const formatDateMDY = (entry: string | undefined) =>
	typeof entry === 'string' && entry.length < 11 && entry.split('-').length === 3
		? new Date(`${entry}T00:00:00`).toLocaleDateString('en-US', {
				day: '2-digit',
				month: '2-digit',
				year: 'numeric',
		  })
		: entry;

export default function DateTextInput({
	label,
	name,
	type = 'text',
	value,
	showError,
	errMsg,
	labelSpacing,
	tagData,
	validations,
	reset,
}: DateTextInputElement) {
	const inputRef = useMask({
		mask: maskStr,
		showMask: true,
		separate: true,
		replacement: { D: /\d/, M: /\d/, Y: /\d/ },
	});

	return (
		<>
			{(label || labelSpacing) && (
				<InputLabel
					className={`${cssprefix}label-spacer-${labelSpacing && !label ? labelSpacing : 'nn'}`}
					data-testid={`${name}-date-text`}
					htmlFor={name}
				>
					{label || ' '}
				</InputLabel>
			)}
			<TextField
				variant="outlined"
				type={type}
				name={name}
				id={name}
				placeholder={'MM/DD/YYYY'}
				onChange={(e) => {
					if (e.target.value.length === 1 && /\d/.test(e.target.value)) {
						e.target.value = `${e.target.value}${maskStr.slice(1)}`;
						e.target.setSelectionRange(1, 1);
					}
					if (e.target.value.length === 1 && !/\d/.test(e.target.value)) {
						e.target.value = '';
						e.target.setSelectionRange(0, 0);
					}
					if (e.target.value.length > 0 && !/\d/.test(e.target.value)) {
						e.target.value = '';
					}
					return publish('formDataUpdate', [name, e.target.value, validations, reset, 'date-text-input']);
				}}
				onBlur={() => publish('markInteracted', name)}
				defaultValue={formatDateMDY(value as string)}
				error={showError}
				helperText={<Typography variant="errorValidation">{errMsg}</Typography>}
				inputRef={value ? inputRef : null}
				inputProps={flattenIntoKey(tagData, 'data')}
			/>
		</>
	);
}
